export const PointerRadiusDistance = 3